import { gql } from "@apollo/client";

const PUBLISHED_QUERY = gql`
  query published_changelist {
    changelist {
      id
      description
      published_on
      status
      published_by {
        name
        email
      }
    }
  }
`;

const OPEN_FILES_QUERY = gql`
  query query_changelist_file($id: String, $opened_paths: [String]) {
    changelist(id: $id) {
      id
      description
      status
      archived
      opened_files: files(paths: $opened_paths) {
        id
        path
        text
      }
    }
  }
`;

const DIFF_VIEW_QUERY = gql`
  query diff_view($draft_id: String!) {
    currentDraft: changelist(id: $draft_id) {
      id
      description
      status
      archived
      all_files: files {
        id
        path
      }
      compilation_result {
        declarations {
          name
          connector_type
          path
          line
          column
          declaration_type
          test
          key_name
        }
        messages {
          type
          path
          line
          column
          message
          startLine
          endLine
          startColumn
          endColumn
        }
      }
      flow_summary {
        purpose
        unfinished
        succeeded
        failed
        dirty_rows_all
        dirty_rows_some
      }
    }
    publishedDraft: changelist {
      id
      description
      status
      archived
      all_files: files {
        id
        path
      }
    }
  }
`;

const DIFF_OPEN_FILES_QUERY = gql`
  query diff_open_files(
    $draft_id: String!
    $published_id: String!
    $draft_opened_paths: [String]
    $published_opened_paths: [String]
  ) {
    currentDraft: changelist(id: $draft_id) {
      id
      description
      status
      archived
      opened_files: files(paths: $draft_opened_paths) {
        id
        path
        text
      }
    }
    publishedDraft: changelist(id: $published_id) {
      id
      description
      status
      archived
      opened_files: files(paths: $published_opened_paths) {
        id
        path
        text
      }
    }
  }
`;

const PUBLISHED_DIFF_OPEN_FILES = gql`
  query published_diff_open_files(
    $draft_id: String!
    $draft_opened_paths: [String]
    $published_opened_paths: [String]
  ) {
    currentDraft: changelist(id: $draft_id) {
      id
      description
      status
      archived
      opened_files: files(paths: $draft_opened_paths) {
        id
        path
        text
      }
    }
    publishedDraft: changelist {
      id
      description
      status
      archived
      opened_files: files(paths: $published_opened_paths) {
        id
        path
        text
      }
    }
  }
`;

const CHANGELIST_DIFF_QUERY = gql`
  query changelist_diff_files($original_id: String, $modified_id: String!) {
    changelist_diff(original_id: $original_id, modified_id: $modified_id) {
      unchanged_files
      modified_files
      deleted_files
      created_files
    }
  }
`;

const CHANGELIST_QUERY = gql`
  query query_just_changelist($id: String) {
    changelist(id: $id) {
      id
      description
      status
      archived
      all_files: files {
        id
        path
      }
      compilation_result {
        declarations {
          name
          connector_type
          path
          line
          column
          declaration_type
          test
          key_name
        }
        messages {
          type
          path
          line
          column
          message
          startLine
          startColumn
          endLine
          endColumn
        }
      }
      flow_summary {
        purpose
        unfinished
        succeeded
        failed
        dirty_rows_all
        dirty_rows_some
      }
    }
  }
`;

const CHANGELIST_OUTDATED_QUERY = gql`
  query changelist_outdated($id: String) {
    changelist(id: $id) {
      needs_merge
    }
  }
`;

export {
  CHANGELIST_DIFF_QUERY,
  CHANGELIST_OUTDATED_QUERY,
  CHANGELIST_QUERY,
  DIFF_OPEN_FILES_QUERY,
  DIFF_VIEW_QUERY,
  OPEN_FILES_QUERY,
  PUBLISHED_DIFF_OPEN_FILES,
  PUBLISHED_QUERY,
};
